import { commonUtils as b } from "@sunrise/shared";
import { trackLink as k } from "@sunrise/tracking";
import { defineComponent as L, ref as s, reactive as E, onMounted as H, onUnmounted as I } from "vue";
import { HeaderNavLevel as M, buildTrackingData as N } from "./index570.js";
const O = L({
  name: "MsNavBar",
  props: {
    channelName: {
      type: String,
      required: !0
    },
    navigationItems: Array
  },
  setup(l) {
    const a = s(null), n = s([]), c = s([]);
    let r;
    const o = E({
      suppressHighlight: !1
    });
    H(() => {
      r = new IntersectionObserver(p, {
        root: a.value,
        threshold: 1
      }), m();
    }), I(() => r.disconnect());
    function m() {
      n.value.forEach((e) => {
        r.observe(e);
      });
    }
    function f(e) {
      const t = c.value.filter((i) => i.target === n.value[e]);
      return t.length !== 1 || t[0].intersectionRatio === 1;
    }
    function p(e) {
      c.value = e;
    }
    function g(e, t, i, u) {
      const d = N(e, t, l.channelName, i);
      return k(u, u.currentTarget, d);
    }
    function v() {
      o.suppressHighlight = !0;
    }
    function h() {
      o.suppressHighlight = !1;
    }
    return {
      navLevel2: M.LEVEL2,
      getRel: b.getRel,
      isVisible: f,
      linkTracking: g,
      onMouseEnter: v,
      onMouseLeave: h,
      state: o,
      wrapper: a,
      items: n
    };
  }
});
export {
  O as default
};
